export const firebaseConfig = {
  apiKey: 'AIzaSyAulhKhxpBw_anaINqS97-TlFatlKNfcIU',
  authDomain: 'domustudio-cloud-go.firebaseapp.com',
  projectId: 'domustudio-cloud-go',
  storageBucket: 'domustudio-cloud-go.appspot.com',
  messagingSenderId: '119060614685',
  appId: '1:119060614685:web:3532bda6ea7809b44a00f4',
  measurementId: 'G-2XZ2GVVZ50'
};

export const VAPID = 'BICfrN4c_SUcRL_QA_5aWSg9z5neSWxW5gczr36819gD_-2VRzYwEqWCKeHiFQXqecI459cTE8U2CTB0q0LDGys';
